<template>
  <v-form ref="form" v-model="formValido">
    <v-card class="rounded-xl pa-4" elevation="0" border>
      <v-card-text>
        <v-row dense>
          <v-col cols="12" md="6">
            <v-text-field label="Usuario (Login)" v-model="usuario.usuario" :rules="reglas" outlined dense prepend-inner-icon="mdi-account-circle"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Nombre Completo" v-model="usuario.nombre" :rules="reglas" outlined dense prepend-inner-icon="mdi-badge-account-horizontal"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="DNI" v-model="usuario.dni" outlined dense></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-text-field label="Teléfono" v-model="usuario.telefono" outlined dense prepend-inner-icon="mdi-phone"></v-text-field>
          </v-col>
          <v-col cols="12">
            <v-text-field label="Correo Electrónico" v-model="usuario.correo" outlined dense prepend-inner-icon="mdi-email-outline"></v-text-field>
          </v-col>
          <v-col cols="12" md="6">
            <v-select 
              label="Rol de Acceso" 
              v-model="usuario.rol" 
              :items="[{text:'Administrador', value:'1'}, {text:'Vendedor', value:'2'}]"
              outlined dense
              :disabled="bloquearRol"
            ></v-select>
          </v-col>
          <v-col cols="12" md="6">
             <v-file-input
                label="Foto de Perfil"
                prepend-icon="mdi-camera"
                accept="image/*"
                @change="alSeleccionarFoto"
                outlined dense
            ></v-file-input>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pb-4 px-4">
        <v-btn text @click="$router.push({ name: 'Usuarios' })">Cancelar</v-btn>
        <v-spacer></v-spacer>
        <v-btn color="#4318FF" dark large class="rounded-lg px-8" @click="enviar" :disabled="!formValido">
            <v-icon left>mdi-content-save</v-icon> GUARDAR USUARIO
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</template>

<script>
export default {
  props: ["usuario", "bloquearRol"],
  data: () => ({
    formValido: false,
    archivoFoto: null,
    reglas: [v => !!v || "Este campo es obligatorio"]
  }),
  methods: {
    alSeleccionarFoto(archivo) {
      this.archivoFoto = archivo;
    },
    enviar() {
      if (this.$refs.form.validate()) {
       
        this.$emit("guardado", { 
            datos: { ...this.usuario }, 
            foto: this.archivoFoto 
        });
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// src/components/Usuarios/FormUsuario.vue